/* @generated */

// src/assets/ui-icon/fill/thumbs-up.tsx
import * as React from "react";
var ThumbsUpFill = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.866 9.99h-2.55l.385-2.11a2.876 2.876 0 0 0-2.83-3.39h-.795l-.92 3.68c-.035.145-.1.28-.185.4-.09.12-.2.22-.325.295l-1.37.825c-.33.2-.71.305-1.095.305H5.02v6.715l3.885 1.945c.45.225.95.34 1.455.345h5.595c.54 0 1.06-.195 1.47-.545.41-.35.675-.84.755-1.37l.83-4.535c.04-.315.015-.64-.075-.945a2.297 2.297 0 0 0-.46-.83 2.211 2.211 0 0 0-.77-.57A2.251 2.251 0 0 0 16.77 10h-2.1",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
));
export {
  ThumbsUpFill
};
